module.exports = __webpack_public_path__ + "static/media/Colette Curve King Headboard - 180 cm_Brown.3fbcc997.png";